module.exports = __webpack_public_path__ + "static/media/ic-sort-time-fill.0b3243e1.svg";